export default function LoadingDots({ className = "bg-black" }) {
  return (
    <div className="flex mt-5 space-x-2 justify-center items-center">
      <span className="sr-only">Loading...</span>
      <div
        className={`h-4 w-4 rounded-full animate-bounce [animation-delay:-0.3s] ${className}`}
      ></div>
      <div
        className={`h-4 w-4 rounded-full animate-bounce [animation-delay:-0.15s] ${className}`}
      ></div>
      <div className={`h-4 w-4 rounded-full animate-bounce ${className}`}></div>
    </div>
  );
}
